<template>
  <div class="nstock-list-page">
    <main-header :hasBanner="true" :type="'nstock'"></main-header>
    <section class="main-center">
      <el-breadcrumb class="bread-list">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="#/nstock">二手房</a></el-breadcrumb-item>
        <el-breadcrumb-item>二手房公示</el-breadcrumb-item>
      </el-breadcrumb> 

      <div class="right-top">
        <el-input
          @keyup.enter.native="search"
          class="ad-input"
          v-model="searchObj.name"
          placeholder="请输入名称"
          type="text"
        />
        <div class="search-btn" @click="search">查&nbsp;&nbsp;询</div>
      </div>
      <div class="search-box">
        <div class="search-item">
          <div class="search-item-left">
            <img src="@/assets/img/search-d.png" alt="" />
            区域
          </div>
          <div class="search-item-right">
            <a v-for="item in cityList" :key="item.value" href="#/nrent/list">{{
              item.label
            }}</a>
          </div>
        </div>
        <div class="search-item">
          <div class="search-item-left">
            <img src="@/assets/img/search-x.png" alt="" />
            租金
          </div>
          <div class="search-item-right">
            <a v-for="item in moneyList" :key="item.id" href="#/nrent/list">{{
              item.label
            }}</a>
          </div>
        </div>
        <div class="search-item">
          <div class="search-item-left">
            <img src="@/assets/img/search-b.png" alt="" />
            其他
          </div>
          <div class="search-item-right">
            <a v-for="item in otherList" :key="item.id" href="#/nrent/list">{{
              item.label
            }}</a>
          </div>
        </div>
      </div>
      <div class="more-select">
        <div class="more-label">更多找房条件</div>
        <div class="more-right">
          <el-select class="more-select-item" placeholder="建造年代">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>

          <el-select class="more-select-item" placeholder="楼层">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>

          <el-select class="more-select-item" placeholder="装修标准">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <el-tabs v-model="activeName" class="tab-bottom-box">
        <el-tab-pane label="全部" name="first">
          <el-table :data="signTable" style="width: 100%">
            <el-table-column
              align="centet"
              header-align="center"
              prop="code"
              label="房源核验统一编码"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="districtName"
              label="所属城区"
            ></el-table-column>

            <el-table-column
              align="centet"
              header-align="center"
              prop="communityName"
              label="小区"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="architarea"
              label="面积"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="houseprice"
              label="委托价格"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="companyName"
              label="挂牌机构"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="startDate"
              label="挂牌时间"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              label="详细"
              width="80"
            >
              <template slot-scope="scope">
                <img
                  @click="goDetail(scope.row)"
                  style="width: 20px; cursor: pointer"
                  src="@/assets/img/search.png"
                  alt=""
                />
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="个人发布" name="second">
          <el-table :data="signTable" style="width: 100%">
            <el-table-column
              align="centet"
              header-align="center"
              prop="code"
              label="房源核验统一编码"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="districtName"
              label="所属城区"
            ></el-table-column>

            <el-table-column
              align="centet"
              header-align="center"
              prop="communityName"
              label="小区"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="architarea"
              label="面积"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="houseprice"
              label="委托价格"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="companyName"
              label="挂牌机构"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="startDate"
              label="挂牌时间"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              label="详细"
              width="80"
            >
              <template slot-scope="scope">
                <img
                  @click="goDetail(scope.row)"
                  style="width: 20px; cursor: pointer"
                  src="@/assets/img/search.png"
                  alt=""
                />
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="经纪机构发布" name="third">
          <el-table :data="signTable" style="width: 100%">
            <el-table-column
              align="centet"
              header-align="center"
              prop="code"
              label="房源核验统一编码"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="districtName"
              label="所属城区"
            ></el-table-column>

            <el-table-column
              align="centet"
              header-align="center"
              prop="communityName"
              label="小区"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="architarea"
              label="面积"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="houseprice"
              label="委托价格"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="companyName"
              label="挂牌机构"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              prop="startDate"
              label="挂牌时间"
            >
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              label="详细"
              width="80"
            >
              <template slot-scope="scope">
                <img
                  @click="goDetail(scope.row)"
                  style="width: 20px; cursor: pointer"
                  src="@/assets/img/search.png"
                  alt=""
                />
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </section>
    <div style="height: 42px"></div>
    <main-footer></main-footer>
  </div>
</template>

<script>
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import { districtList } from "@/assets/api/common";

export default {
  name: "NstockList",
  components: {
    mainHeader,
    mainFooter,
  },
  data() {
    return {
      searchObj: {},
      options: [],
      activeName: "first",
      gzdt: [],
      sdyw: [],
      lcyw: [],

      cityList: [],
      moneyList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "3000以下",
          label: "3000以下",
        },
        {
          value: "3000-4000",
          label: "3000-4000",
        },
        {
          value: "4000-5000",
          label: "4000-5000",
        },
        {
          value: "5000-6000",
          label: "5000-6000",
        },
        {
          value: "6000-8000",
          label: "6000-8000",
        },
      ],
      otherList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "两室两厅",
          label: "两室两厅",
        },
        {
          value: "三室一厅",
          label: "三室一厅",
        },
        {
          value: "四室一厅",
          label: "四室一厅",
        },
        {
          value: "70-90m²",
          label: "70-90m²",
        },
        {
          value: "120-150m²",
          label: "120-150m²",
        },
      ],
    };
  },
  mounted() {
    this.initCity();
  },
  methods: {
    async initCity() {
      const res = await districtList();
      this.cityList = ((res && res.data && res.data.data) || []).map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });
      this.cityList.unshift({
        value: null,
        label: "全部",
      });
    },
    goDetail(item) {
      const jumpUrl = this.$router.resolve({
        path: "/resources/detail",
        query: { id: item.id },
      });
      window.open(jumpUrl.href, "_blank");
    },
    search() {},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less">
.nstock-list-page {
  .bread-list {
    margin-bottom: 14px;
    .el-breadcrumb__item {
      font-size: 15px;
    }
    .el-breadcrumb__inner a:hover,
    .el-breadcrumb__inner.is-link:hover {
      color: #b1191a;
    }
  }
  .search-box {
    border: 1px solid #ececec;
    border-bottom: none;
    .search-item {
      display: flex;
      border-bottom: 1px solid #ececec;
      .search-item-left {
        width: 220px;
        background: #fafafa;
        text-align: center;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        img {
          width: 24px;
          margin: 12px;
          height: auto;
        }
      }
      .search-item-right {
        flex: 1;
        padding: 18px 18px 0 28px;
        border-left: 1px solid #e8e8e8;
        display: flex;
        flex-wrap: wrap;
        a {
          font-size: 14px;
          padding: 6px 12px;
          margin-right: 20px;
          cursor: pointer;
          margin-bottom: 18px;
          background: #efefef;
          &:hover {
            color: #fff;
            background: #b1191a;
          }
        }
      }
    }
  }
  .right-top {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto;

    .ad-input {
      flex: 1;
      height: 50px;
      border: 1px solid #dcdfe6;
      border-right: 0;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      input {
        height: 100%;
        border: none;
      }
    }
    .search-btn {
      background: #9b2f3d;
      width: 140px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #fff;
      font-weight: bold;
      font-size: 16px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      cursor: pointer;
    }
  }
  .more-select {
    background: #fafafa;
    border: 1px solid #ececec;
    border-top: none;
    display: flex;
    .more-label {
      padding: 24px 0;
      width: 220px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      flex-shrink: 0;
    }
    .more-right {
      flex: 1;
      height: 67px;
      padding: 0 18px 0 28px;
      border-left: 1px solid #e8e8e8;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .more-select-item {
        margin-right: 18px;
      }
    }
  }
  .tab-bottom-box {
    margin: 42px 0;
    position: relative;

    .el-tabs__item {
      line-height: 1;
      height: 34px;
      font-size: 18px;
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__item.is-active {
      color: #b1191a;
      &:hover {
        color: #b1191a;
      }
    }
    .el-tabs__item:hover {
      color: #b1191a;
    }
    .el-tabs__active-bar {
      background-color: #b1191a;
    }
  }
}
</style>
